import {
    UPDATE_DRAFT_BID_PROFILE,
    UPDATE_DRAFT_BID_PROFILE_OBJECTS,
    UPDATE_DRAFT_BIDDING_INFORMATION,
    UPDATE_DRAFT_ORIGINAL_BIDDING_INFORMATION,
    UPDATE_DRAFT_SCHEDULE_SELECTION,
    CHECK_DRAFT_SCHEDULE_ITEM,
    CHECK_ALL_DRAFT_SCHEDULE_ITEM,
    CHECK_DRAFT_WORKPLAN_SCHEDULE_ITEM,
    CHECK_ALL_DRAFT_WORKPLAN_SCHEDULE_ITEM,
    UPDATE_DRAFT_SCHEDULE_SELECTION_SELECTED_WORKPLAN,
    UPDATE_DRAFT_ORIGINAL_SCHEDULE_SELECTION,
    UPDATE_DRAFT_EMPLOYEES_SELECTION,
    UPDATE_DRAFT_ORIGINAL_EMPLOYEES_SELECTION,
    UPDATE_DRAFT_BID_PROFILE_SCHEDULE,
    UPDATE_DRAFT_ORIGINAL_BID_PROFILE_SCHEDULE,
    RESET_DRAFT_BID_PROFILE,
} from './bidProfileDraft.actions';
import {
    BidProfileEditTab, AnchorDay, EmployeeSubmissionTimeUnit, PeriodType,
} from '../../../Enums';
import TimeService from '../../../services/TimeService';

/**
 * @type {BiddingDraft.IDraftBidProfileSchedulingAccordion}
 */
const defaultScheduleAndVisibility = {
    submissionPeriodStartDate: null,
    submissionPeriodEndDate: null,
    requestPeriodStartDate: null,
    requestPeriodEndDate: null,
    dayOfTheWeek: {
        0: false, 1: true, 2: true, 3: true, 4: true, 5: true, 6: false,
    },
    startBiddingTime: TimeService.getDateTimeFromMinutes(420),
    endBiddingTime: TimeService.getDateTimeFromMinutes(960),
    timePerEmployeeUnit: EmployeeSubmissionTimeUnit.Minute,
    timePerEmployeeValue: 1,
    isAnytime: false,
    isVisibilityEnabled: false,
    daysBeforeVisibility: 0,
    isExpanded: false,
    isEditable: false,
    sequentialSchedule: {},
    isCompleted: false,
};

/**
 * @type {BiddingDraft.IBidProfileDraft}
 */
const initialState = {
    id: '',
    draftId: '',
    creationDate: null,
    lastUpdate: null,
    managerId: '',
    status: -1,
    anchorDay: AnchorDay.Sunday,
    tabSelected: BidProfileEditTab.Form,
    isRebidAllowed: false,
    isRebid: false,
    rebidNumber: 0,
    rebidParents: [],
    maxScheduleRowItems: 0,
    isWorkPlansRetrieved: false,
    isReImportNeeded: false,
    originalRequestPeriodEndDateIsForever: false,
    originalRequestPeriodEndDate: null,
    bidProfileInformation: {
        name: '',
        description: '',
        bidSetupId: -1,
        bidProcessType: -1,
        scheduleSource: -1,
        isExpanded: true,
        isCompleted: false,
        isEditable: true,
    },
    originalBidProfileInformation: {
        name: '',
        description: '',
        bidSetupId: -1,
        bidProcessType: -1,
        scheduleSource: -1,
        isExpanded: true,
        isCompleted: false,
        isEditable: true,
    },
    scheduleTemplates: {
        items: [],
        shifts: {},
        paycodes: {},
        selected: [],
        isExpanded: false,
        isCompleted: false,
        isEditable: true,
        isReImportNeeded: false,
        retrievedWorkplans: null,
        dayCount: 0,
        periodType: PeriodType.Weeks,
        isActiveWorkplanBid: false,
        activeWorkplanStartDate: null,
        activeWorkplanEndDate: null,
    },
    originalScheduleTemplates: {
        items: [],
        shifts: {},
        paycodes: {},
        selected: [],
        isExpanded: false,
        isCompleted: false,
        isEditable: true,
        isReImportNeeded: false,
        retrievedWorkplans: null,
        dayCount: 0,
        periodType: PeriodType.Weeks,
        isActiveWorkplanBid: false,
        activeWorkplanStartDate: null,
        activeWorkplanEndDate: null,
    },
    employees: {
        employeesIds: [],
        hyperfindId: undefined,
        hyperfindLabel: '',
        periodSelected: {
            startDate: null,
            endDate: null,
        },
        rankedEmployees: [],
        isExpanded: false,
        isCompleted: false,
        isEditable: true,
        lockedEmployeeIds: [],
    },
    originalEmployees: {
        employeesIds: [],
        hyperfindId: undefined,
        hyperfindLabel: '',
        periodSelected: {
            startDate: null,
            endDate: null,
        },
        rankedEmployees: [],
        isExpanded: false,
        isCompleted: false,
        isEditable: true,
        lockedEmployeeIds: [],
    },
    schedule: {
        ...defaultScheduleAndVisibility,
        isExpanded: false,
        isCompleted: false,
        isEditable: true,
    },
    originalSchedule: {
        ...defaultScheduleAndVisibility,
        isExpanded: false,
        isCompleted: false,
        isEditable: true,
    },
    isCompleteDraftActionProcessing: false,
    managerWarnings: [],
    isUploadingSchedule: false,
};

/**
 * @param { BiddingDraft.IBidProfileDraft } state
 * @param { ShiftBidding.IAction} action
* */
// eslint-disable-next-line default-param-last
export default function bidProfileDraftReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case UPDATE_DRAFT_BID_PROFILE:
            return {
                ...state,
                ...payload,
            };
        case UPDATE_DRAFT_BID_PROFILE_OBJECTS:
            return {
                ...state,
                ...payload.general,
                bidProfileInformation: {
                    ...state.bidProfileInformation,
                    ...payload.bidProfileInformation,
                },
                scheduleTemplates: {
                    ...state.scheduleTemplates,
                    ...payload.scheduleTemplates,
                },
                employees: {
                    ...state.employees,
                    ...payload.employees,
                },
                schedule: {
                    ...state.schedule,
                    ...payload.schedule,
                },
            };
        case UPDATE_DRAFT_BIDDING_INFORMATION:
            return {
                ...state,
                bidProfileInformation: {
                    ...state.bidProfileInformation,
                    ...payload,
                },
            };
        case UPDATE_DRAFT_ORIGINAL_BIDDING_INFORMATION:
            return {
                ...state,
                originalBidProfileInformation: {
                    ...state.originalBidProfileInformation,
                    ...payload,
                },
            };
        case CHECK_DRAFT_SCHEDULE_ITEM: {
            const index = state.scheduleTemplates.items.findIndex((x) => x.id === payload.id);
            state.scheduleTemplates.items[index].isSelected = payload.checked;
            const items = [...state.scheduleTemplates.items];
            return {
                ...state,
                scheduleTemplates: {
                    ...state.scheduleTemplates,
                    items,
                },
            };
        }
        case CHECK_ALL_DRAFT_SCHEDULE_ITEM: {
            const items = state.scheduleTemplates.items.map((x) => ({ ...x, isSelected: payload.checked }));
            return {
                ...state,
                scheduleTemplates: {
                    ...state.scheduleTemplates,
                    items,
                },
            };
        }
        case CHECK_DRAFT_WORKPLAN_SCHEDULE_ITEM: {
            const workplanIndex = state.scheduleTemplates.retrievedWorkplans?.workplans
                .findIndex((x) => x.workplanId === payload.workplanId);
            if (workplanIndex === -1) {
                return state;
            }
            const updatedWorkplan = state.scheduleTemplates.retrievedWorkplans.workplans[workplanIndex];
            const index = updatedWorkplan.scheduleTemplates.items.findIndex((x) => x.id === payload.id);
            updatedWorkplan.scheduleTemplates.items[index].isSelected = payload.checked;

            const workplans = [...state.scheduleTemplates.retrievedWorkplans.workplans];
            return {
                ...state,
                scheduleTemplates: {
                    ...state.scheduleTemplates,
                    retrievedWorkplans: {
                        ...state.scheduleTemplates.retrievedWorkplans,
                        workplans,
                    },
                },
            };
        }
        case CHECK_ALL_DRAFT_WORKPLAN_SCHEDULE_ITEM: {
            const workplanIndex = state.scheduleTemplates.retrievedWorkplans?.workplans
                .findIndex((x) => x.workplanId === payload.workplanId);
            if (workplanIndex === -1) {
                return state;
            }
            const updatedWorkplan = state.scheduleTemplates.retrievedWorkplans.workplans[workplanIndex];
            updatedWorkplan.scheduleTemplates.items = updatedWorkplan.scheduleTemplates.items
                .map((i) => ({
                    ...i,
                    isSelected: payload.checked,
                }));
            const workplans = [...state.scheduleTemplates.retrievedWorkplans.workplans];

            return {
                ...state,
                scheduleTemplates: {
                    ...state.scheduleTemplates,
                    retrievedWorkplans: {
                        ...state.scheduleTemplates.retrievedWorkplans,
                        workplans,
                    },
                },
            };
        }
        case UPDATE_DRAFT_SCHEDULE_SELECTION_SELECTED_WORKPLAN:
            return {
                ...state,
                scheduleTemplates: {
                    ...state.scheduleTemplates,
                    selected: [...payload],
                },
            };
        case UPDATE_DRAFT_SCHEDULE_SELECTION:
            return {
                ...state,
                scheduleTemplates: {
                    ...state.scheduleTemplates,
                    items: [...state.scheduleTemplates.items],
                    ...payload,
                },
            };
        case UPDATE_DRAFT_ORIGINAL_SCHEDULE_SELECTION:
            return {
                ...state,
                originalScheduleTemplates: {
                    ...state.originalScheduleTemplates,
                    items: [...state.originalScheduleTemplates.items],
                    ...payload,
                },
            };
        case UPDATE_DRAFT_EMPLOYEES_SELECTION:
            return {
                ...state,
                employees: {
                    ...state.employees,
                    ...payload,
                },
            };
        case UPDATE_DRAFT_ORIGINAL_EMPLOYEES_SELECTION:
            return {
                ...state,
                originalEmployees: {
                    ...state.originalEmployees,
                    ...payload,
                },
            };
        case UPDATE_DRAFT_BID_PROFILE_SCHEDULE:
            return {
                ...state,
                schedule: {
                    ...state.schedule,
                    ...payload,
                },
            };
        case UPDATE_DRAFT_ORIGINAL_BID_PROFILE_SCHEDULE:
            return {
                ...state,
                originalSchedule: {
                    ...state.originalSchedule,
                    ...payload,
                },
            };
        case RESET_DRAFT_BID_PROFILE:
            return initialState;
        default:
            return state;
    }
}
